/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Switch } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { AiOutlineShoppingCart, AiOutlineWhatsApp } from "react-icons/ai";
import { BiMessageEdit } from "react-icons/bi";
import { CgMenuCheese } from "react-icons/cg";
import { FaDownload, FaEnvelope } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { TbLayoutDashboard } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import logo from "../../images/logo1.png";
import { getMyInfo, getMyMessages, getMyOrder, userLogout } from "../../redux/actions/frontendActions/authenticationAction";
import { getResume } from "../../redux/actions/frontendActions/resumeAction";

function Navbar() {
  const dispatch = useDispatch();
  let timeOfDay;
  const date = new Date();
  const hours = date.getHours();
  const styles = {
    fontSize: 12,
  }

  if (hours < 12) {
    timeOfDay = 'morning';
    styles.color = "#005ECA";
  } else if (hours >= 12 && hours < 17) {
    timeOfDay = 'afternoon';
    styles.color = "#04733F";
  } else {
    timeOfDay = 'night';
    styles.color = "#04756F";
  }

  const {resume} =useSelector(state => state.Resume);

  const cv =resume[0]?.link
 

  const { editProfile, authenticate ,myInfo ,myMessages ,  myOrder} = useSelector((state) => state.Auth);
  const [click, setClick] = useState(false);
  const [switchActive, setSwicthActive] = useState(false);
  const handleSwitch = (e) => {
    setSwicthActive(!switchActive);
  };
  

  const handleMenuClick = (e) => {
    setClick(!click);
  };
  const [hideInfo , setHideInfo] = useState(true);
  const manageHide =()=>{
    setHideInfo(!hideInfo)
  }
 
  const handleLogout=()=>{
    dispatch(userLogout())
  }

  useEffect(() =>{
    dispatch(getResume())
  },[ dispatch , editProfile]);

  useEffect(() => {
    dispatch(getMyInfo(myInfo.id));
    dispatch(getMyMessages(editProfile.email));
    dispatch(getMyOrder(editProfile.email))
  }, [myInfo.id , editProfile.email]);


  return (
    <>
      <nav className="padding_container">
        <Link to="/">
          <img className="navbar-logo-width" src={logo} alt="" />
        </Link>
        <div>
          <ul id="navbar" className={click ? "#navbar active" : "#navabr"}>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/about-me">About me</NavLink>
            </li>
            <li>
              <NavLink to="/portfolio">Portfolio</NavLink>
            </li>
            <li>
              <NavLink to="/service">Services</NavLink>
            </li>
          
            <li>
              <NavLink to="/blogs">Blogs</NavLink>
            </li>
            <li>
              <NavLink to="/pricing">Pricing</NavLink>
            </li>
            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
            {authenticate ? (

              <li className={click ? "userdetails-area-view hide": "userdetails-area-view"}>
                <div className="navbar_image-icon">
                  <img onClick={manageHide} src={editProfile.image} alt="" />

                  <div className={hideInfo ? "navbar-user-details-card hide": "navbar-user-details-card"}>
                    <div className="top-area">
                      <img src={editProfile.image} alt="" />
                      <h5 style={styles}>Hey! Good {timeOfDay}!</h5>
                      <h4>{`${editProfile.firstName} ${editProfile.lastName}`}</h4>
                      
                  
                          <h6>status :- {editProfile?.status}</h6>
                      
                     
                      <Link to="/myProfile">
                        
                        <button>View Profile</button>
                      </Link>
                   
                    </div>
                    <hr />
                    <div className="render_area_of_user">
                      {
                        editProfile.email === "iasraful107@gmail.com" &&
                        
                        <Link to="/admin/dashboard" className="render">
                        <TbLayoutDashboard/>
                        <h5>Admin Dashboard</h5>
                      </Link>
                      }
                      <Link to="/myProfile" className="render">
                        <AiOutlineShoppingCart/>
                        <h6 className="navbar-length-badge">{ myOrder.length}</h6>
                        <h5>Orders</h5>
                      </Link>
                     
                      <Link to="/myProfile" className="render">
                        <BiMessageEdit/>
                        <h5>Edit Profile</h5>
                      </Link>
                      <Link to="/myProfile" className="render">
                        <FaEnvelope/>
                        <h6 className="navbar-length-badge">{myMessages.length}</h6>
                        <h5>My Messages</h5>
                      </Link>

                      <Link to="#" className="render" onClick={handleLogout}>
                        <RiLogoutBoxRLine/>
                        <h5>Logout</h5>
                      </Link>
                    </div>
                   
                  </div>
                </div>
              </li>
            ) : (
              <li>
                <NavLink to="/register">Account</NavLink>
              </li>
            )}

          
          </ul>
        </div>
        <div className="mobile_button">
          {switchActive ? (
            <a href={cv} target="_blank" rel="noopener" className="btn-area">
              <Button>
                <FaDownload /> resume
              </Button>
            </a>
          ) : (
            <a
              href="https://wa.me/+8801758015756"
              target="_blank"
              className="btn-area"
              rel="noreferrer"
            >
              <Button>
                <AiOutlineWhatsApp /> whatsapp
              </Button>
            </a>
          )}
          <div className="switch_area">
            <Switch name="switch" onChange={handleSwitch} size="xs" />
          </div>
        </div>
        <div id="mobile" onClick={handleMenuClick}>
          {click ? <MdOutlineClose size={25} /> : <CgMenuCheese size={25} />}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
